import { ListUserDto } from "./user.models";

export interface EventDto {	
	EventId: string;
	EventType: EventType;
	EventDate: Date;
	User: ListUserDto;
	SourceId: string;
	SourceType: EventSource;
	SourceDescription: string;
	TargetId: string;
	TargetType: EventTarget | null;
	TargetDescription: string;
}

export enum EventType {
	None = 0,
	Read = 1,
	Created = 2,
	Updated = 3,
	Deleted = 4,
	Commented = 5,
	Requested = 6,
	Approved = 7,
	Declined = 8,
	Assigned = 9,
	Overdue = 10
}

export enum EventSource
{
	None = 0,
	WorkOrder = 1,
	Category = 2,
	Location = 3,
	User = 4,
	Team = 5
}

export enum EventTarget
{
	None = 0,
	WorkOrder = 1,
	Category = 2,
	Location = 3,
	User = 4,
	Team = 5,
	Asset = 6,
	Vendor = 7,

	Title = 10,
	Description = 11,
	Status = 12,
	Priority = 13,
	StartedDate = 14,
	DueDate = 15,
	Comment = 16,

	Read = 20
}